import React, { useEffect } from 'react'
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react'

interface EmojiReactionPickerProps {
  onEmojiSelect: (emoji: string) => void
  onClose: () => void
  floatingRef?: (node: HTMLDivElement | null) => void
  floatingStyles?: React.CSSProperties
}

export const EmojiReactionPicker: React.FC<EmojiReactionPickerProps> = ({
  onEmojiSelect,
  onClose,
  floatingRef,
  floatingStyles,
}) => {
  // Handle emoji selection
  const handleEmojiClick = (emojiData: EmojiClickData) => {
    onEmojiSelect(emojiData.emoji)
    onClose()
  }

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [onClose])

  return (
    <div
      ref={floatingRef}
      style={{
        ...floatingStyles,
        position: 'fixed',
      }}
      className="z-[2000] bg-white rounded-2xl shadow-2xl overflow-hidden will-change-transform"
    >
      <EmojiPicker
        onEmojiClick={handleEmojiClick}
        theme={Theme.LIGHT}
        searchPlaceholder="Search emojis..."
        width={350}
        height={450}
        previewConfig={{
          showPreview: false,
        }}
        skinTonesDisabled={false}
        lazyLoadEmojis={true}
      />
    </div>
  )
}
